import { styled } from '@mui/material/styles';
import { TabContext } from '@mui/lab';
import { ChangeEvent, useState } from 'react';
import { useTranslate } from 'react-admin';
import { HotelRecord, Timeframe } from '../../../common/types';
import {
  useAverageDurationHourlyAverageData,
  useAverageDurationTotalData,
  useAverageDurationWeekdayAverageData,
} from '../data-hooks';
import ChartMainTabList from '../shared/ChartMainTabList';
import ChartsCircularProgress from '../shared/ChartsCircularProgress';
import ChartTab from '../shared/ChartTab';
import ChartTabPanel from '../shared/ChartTabPanel';
import UsageTotalsKeenChart from '../UsageTotalsKeenChart';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '100%',
});

const Chart = styled('div')({
  width: '100%',
});

const UsageTotalsChartAverageDuration = ({
  hotel,
  timeframe,
}: {
  hotel: HotelRecord;
  timeframe: Timeframe;
}) => {
  const t = useTranslate();
  const [currentChartTab, setCurrentChartTab] = useState('1');

  const {
    chartProps: averageDurationTotalChartProps,
    loading: isAverageDurationTotalDataLoading,
  } = useAverageDurationTotalData({ hotel, timeframe });
  const {
    chartProps: averageDurationWeekdayAverageDataChartProps,
    loading: isAverageDurationWeekdayAverageDataLoading,
  } = useAverageDurationWeekdayAverageData({ hotel, timeframe });
  const {
    chartProps: averageDurationHourlyAverageDataChartProps,
    loading: isAverageDurationHourlyAverageDataLoading,
  } = useAverageDurationHourlyAverageData({ hotel, timeframe });

  const onCurrentChartTabChange = (
    _event: ChangeEvent<{}>,
    newValue: string
  ) => {
    setCurrentChartTab(newValue);
  };

  return (
    <Container>
      <Chart>
        <TabContext value={currentChartTab}>
          <ChartMainTabList onChange={onCurrentChartTabChange}>
            <ChartTab value="1" label={t('charts.usage.chart-types.totals')} />
            <ChartTab
              value="2"
              label={t('charts.usage.chart-types.weekday-average')}
            />
            <ChartTab
              value="3"
              label={t('charts.usage.chart-types.hourly-average')}
            />
          </ChartMainTabList>
          <ChartTabPanel value="1">
            {isAverageDurationTotalDataLoading ? (
              <ChartsCircularProgress />
            ) : (
              <UsageTotalsKeenChart
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...averageDurationTotalChartProps}
              />
            )}
          </ChartTabPanel>
          <ChartTabPanel value="2">
            {isAverageDurationWeekdayAverageDataLoading ? (
              <ChartsCircularProgress />
            ) : (
              <UsageTotalsKeenChart
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...averageDurationWeekdayAverageDataChartProps}
              />
            )}
          </ChartTabPanel>
          <ChartTabPanel value="3">
            {isAverageDurationHourlyAverageDataLoading ? (
              <ChartsCircularProgress />
            ) : (
              <UsageTotalsKeenChart
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...averageDurationHourlyAverageDataChartProps}
              />
            )}
          </ChartTabPanel>
        </TabContext>
      </Chart>
    </Container>
  );
};

export default UsageTotalsChartAverageDuration;
